import { queryOptions, useQuery } from '@tanstack/react-query'
import {
  getUserNeedsApprovalStats,
  getUserTaskStats,
} from 'src/queries/organizations/activity.network'
import {
  userNeedsApprovalsStatsQueryKeys,
  userTaskStatsQueryKeys,
} from 'src/queries/queries.constants'

export type GetTaskStatsResponse = {
  flaggedTransactionsCount: number
  missingReceiptsCount: number
  missingExpenseCategoriesCount: number
  missingRequiredFieldsCount: number
}

export const userTaskStatsQueries = {
  stats: () =>
    queryOptions({
      queryKey: userTaskStatsQueryKeys.userTaskStats(),
      queryFn: () => getUserTaskStats(),
      retry: false,
    }),
}

export const useQueryGetUserTaskStats = (enabled = true) => {
  return useQuery({
    ...userTaskStatsQueries.stats(),
    enabled,
  })
}

export type GetNeedsApprovalStatsResponse = {
  virtualCardsToApproveCount: number
  budgetsToApproveCount: number
  expensesToReviewCount: number
  reimbursementsToReviewCount: number
  managerReimbursementsToReviewCount: number
}

export const userNeedsApprovalStatsQueries = {
  stats: () =>
    queryOptions({
      queryKey: userNeedsApprovalsStatsQueryKeys.userNeedsApprovalStats(),
      queryFn: () => getUserNeedsApprovalStats(),
      retry: false,
    }),
}

export const useQueryGetUserNeedsApprovalStats = (enabled = true) => {
  return useQuery({
    ...userNeedsApprovalStatsQueries.stats(),
    enabled,
  })
}
